import React, {Component} from 'react';
import classNames from 'classnames';

import Icon from 'lib/struct/icon/Icon';
import IconBox from 'lib/struct/icon/IconBox';

import styles from './IconCheckbox.less';

export default class IconCheckbox extends Component {
    render() {
        const {
            true_icon, false_icon,
            children, className, refNode,
            ...props
        } = this.props;
        const {
            checkbox: checkboxClass,
            checkbox__inputBox: inputBoxClass,
            checkbox__contentBox: contentBoxClass,
            checkbox__input: inputClass
        } = styles;
        const ui_version = window.shop_productgroup.ui_version || '1.3';

        return (
            <label className={[className, checkboxClass].join(' ')}>
                <input type="checkbox" className={inputClass} ref={refNode} {...props} />
                <span className={inputBoxClass}>

					{ui_version === '2.0' ? (
                        <span style={{color: props.checked ? 'green' : 'red'}}>
							<Icon name="circle"/>
						</span>
                    ) : (
                        <Icon name={props.checked ? true_icon : false_icon}/>
                    )}

				</span>

                {children ? (
                    <span className={contentBoxClass}>{children}</span>
                ) : (null)}

            </label>
        );
    }
}